export default __webpack_public_path__ + "static/media/spotify.0ddba2e2.svg";